import React from 'react'
import './userDetail.css'
import Detailed from './More_Detail/more_detail/indexx'

function UserDetails(props) {
    console.log(".........entered.........")
    return (
      <Detailed />
    )
}

export default UserDetails
